var map = {
	"./vs01.webp": 577,
	"./vs02.webp": 4964,
	"./vs03.webp": 4327,
	"./vs04.webp": 5258,
	"./vs05.webp": 6757,
	"./vs06.webp": 5656,
	"./vs07.webp": 8459,
	"./vs08.webp": 414,
	"./vs09.webp": 9513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4378;